/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { navigate } from '../../../../helpers/history';
import Toast from '../../../../components/Toast';
import * as utils from '../../../../shared/utils';
import { showDialog } from '../../../../components/dialog';
import localization from '../../../../shared/strings';
import sdk from '../../../../sdk';
import { isHaveTeammatePermission } from '../../../helpers/user';

const sendAssetsToTranscribe = createAsyncThunk(
  'asset/sendToTranscribe',
  async (
    { assetIds, language, isBulkAIProcess }, { rejectWithValue, getState },
  ) => {
    const { user, roles, teammates } = getState();
    const billingDenied = !isHaveTeammatePermission('manageBilling', user);
    const keywordingDenied = !isHaveTeammatePermission('manageKeywords', user);
    const teamManagingDenied = !isHaveTeammatePermission('manageTeam', user);

    const canNotBuyApiCalls = billingDenied || keywordingDenied || teamManagingDenied;
    const usersWithPermissionsToBuyApiCalls = utils.getUsersWithPermissionToBuyKeywords(user, teammates.items, roles.items);

    try {
      const { data } = await sdk.assets.transcribeSpeechToText(assetIds, language);

      if (!isBulkAIProcess) {
        if (assetIds.length >= 2) {
          Toast(localization.TRANSCRIPT.TOASTS.textTranscribeIPanelInProgress(assetIds.length), { closeButton: false });
        } else {
          Toast(localization.TRANSCRIPT.TOASTS.textTranscribeTPanelInProgress, { closeButton: false });
        }

        if (data.hasNotPermittedAssets) {
          Toast(localization.NO_COLLECTION_PERMISSION_TO_ACCESS('generate speech to text'), { autoClose: false });
        }
      }

      return { assetIds };
    } catch (error) {
      const errorSubcode = utils.getDataFromResponceError(error, 'subcode');
      if (errorSubcode === 'FeatureNotAvailableForPlanError') {
        showDialog({
          title: localization.DIALOGS.UPGRADE_AI_FEATURES.TITLE,
          text: localization.DIALOGS.UPGRADE_AI_FEATURES.TEXT,
          textBtnOk: localization.DIALOGS.UPGRADE_AI_FEATURES.BTN_OK,
          onOk() {
            navigate('/billing?tab=overview');
          },
          textBtnCancel: localization.DIALOGS.UPGRADE_AI_FEATURES.BTN_CANCEL,
        });
      } else if (errorSubcode === 'NotEnoughPaidApiCallsError') {
        showDialog({
          title: localization.TRANSCRIPT.DIALOGS.titleNotEnoughAICredits,
          text: localization.TRANSCRIPT.DIALOGS.textNotEnoughAICredits(canNotBuyApiCalls, usersWithPermissionsToBuyApiCalls),
          textBtnOk: canNotBuyApiCalls ? localization.DIALOGS.btnOk : localization.TRANSCRIPT.DIALOGS.btnNotEnoughAICredits,
          onOk() {
            canNotBuyApiCalls ? Function.prototype() : navigate('/billing?tab=overview');
          },
          textBtnCancel: canNotBuyApiCalls ? null : localization.DIALOGS.btnNotNow,
        });
      }
      return rejectWithValue(error);
    }
  },
);

export default sendAssetsToTranscribe;
